import { getAccessToken, getCurrentOrganizationId } from 'utils/utils';
import { Axios } from 'choerodon-ui/pro';
import { API_HOST } from 'utils/config';
import { getDownloadFileUrl, downloadFile } from '@common/utils/attachment';
import moment from 'moment';
import { v4 as uuid } from 'uuid';
import { AttachmentConfig } from 'choerodon-ui/lib/configure';

const uploadFileConfigure = (): AttachmentConfig => {
  return {
    // attachment: {
      defaultFileKey: 'file',
      defaultFileSize: 500 * 1024 * 1024,
      defaultChunkSize: 5 * 1024 * 1024,
      defaultChunkThreads: 3,
      action({ attachmentUUID }) {
        return {
          url: `/hfle/v1/${getCurrentOrganizationId()}/files/attachment/multipart`,
          headers: {
            Authorization: `bearer ${getAccessToken()}`,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'multipart/form-data; charset=utf-8; ',
          },
          params: {
            attachmentUUID,
          },
        };
      },
      // 附件回显组件列表请求改造
      fetchList({ attachmentUUID }) {
        return Axios.get(
          `${API_HOST}/hfle/v1/${getCurrentOrganizationId()}/files/${attachmentUUID}/file`,
          {
            headers: {
              Authorization: `bearer ${getAccessToken()}`,
            },
          }
        ).then((response: any) => {
          return response.map((file) => ({
            uid: attachmentUUID,
            name: file.fileName,
            size: file.fileSize,
            type: file.fileType,
            url: file.fileUrl,
            bucketName: file.bucketName,
            creationDate: moment(file.creationDate).toDate(),
            status: 'done',
          }));
        });
      },
      async batchFetchCount(uuids) {
        // hack: 暂时用单个接口去模拟批量接口，等后续后端提供了批量接口后再替换掉
        try {
          const configs = {
            headers: {
              Authorization: `bearer ${getAccessToken()}`,
            },
          };
          const requests = uuids
            .filter((v) => !!v)
            .map((attachmentUUID) => {
              const url = `${API_HOST}/hfle/v1/${getCurrentOrganizationId()}/files/${
                (attachmentUUID as unknown) as string
              }/count`;
              return Axios.get(url, configs).then((count) => ({ uuid: attachmentUUID, count }));
            });
          const res: any[] = await Promise.all(requests);
          const result = res.reduce((acc, cur) => {
            acc[cur.uuid] = cur.count;
            return acc;
          }, {});
          return Promise.resolve(result);
        } catch (err) {
          // noop
        }
      },
      // 附件上传点击删除按钮
      onRemove({ attachment, attachmentUUID }) {
        const url = `${API_HOST}/hfle/v1/${getCurrentOrganizationId()}/files/delete-by-uuidurl`;
        const configs = {
          headers: {
            Authorization: `bearer ${getAccessToken()}`,
          },
          params: {
            attachmentUUID,
          },
        };
        const data = [attachment.url];
        return Axios.post(url, data, configs);
      },
      onOrderChange() {
        return Promise.resolve();
      },
      getAttachmentUUID() {
        return uuid();
      },
      getPreviewUrl({ attachment }) {
        const { url, name, bucketName } = attachment;
        return getDownloadFileUrl({ url, fileName: name, bucketName });
      },
      // 下载全部
      getDownloadAllUrl({ attachmentUUID }) {
        return async () => {
          const url = `${API_HOST}/hfle/v1/${getCurrentOrganizationId()}/files/${attachmentUUID}/file`;
          const headers = {
            Authorization: `bearer ${getAccessToken()}`,
          };
          const res: any = await Axios.get(url, { headers });
          if (!res) {
            return;
          }
          const files = res as Array<any>;
          files.forEach((item) => {
            downloadFile({ url: item.fileUrl, name: item.fileName, bucketName: item.bucketName });
          });
        };
      },
      // Attachment组件的下载点击事件改造
      getDownloadUrl({ attachment }) {
        const { url, name, bucketName } = attachment;
        return getDownloadFileUrl({ url, fileName: name, bucketName });
      },
      // onBeforeUploadChunk(chunk) {
      //   if (chunk) {
      //     // do chunk upload check
      //     console.log(chunk);
      //   }
      // },
      onUploadSuccess(resp, attachment) {
        console.log('onUploadSuccess', resp, attachment);
        if (resp) {
          attachment.url = resp; // 把服务端的url复制给attachment对象的url
        }
      },
      renderHistory() {
        return 'empty';
      },
    // },
  };
};

export default uploadFileConfigure;

